(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kr-editorial-style"] && !Shopify.designMode) return;
  try {
    const krUpdateHeader=()=>document.body.classList.toggle('kr-scrolled',window.scrollY>30);
  window.addEventListener('scroll',krUpdateHeader,{passive:true});krUpdateHeader();
  } catch(e) { console.error(e); }
})();

})();
